module.exports = __webpack_public_path__ + "assets/images/groups_esmerald.svg?d2c1fde108c9d8e4272e70d70e44b4b2";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/groups_esmerald.svg
// module id = 615
// module chunks = 0